import store from "core/redux/store";
// Regular function to get token from Redux store
export const getToken = () => {
  const state = store.getState();
  
  return state.auth?.userData?.token || "";
};
